import { DIC } from "@/const/dic";
// import {
//     validateChinese
// } from '@/util/validate'
import { formatterTime } from "@/util/util";

export const addMoneyOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  columnBtn:true,
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  printBtn: true,
  excelBtn: true,
  //viewBtn: true,
  menuWidth: "200",
  labelWidth: "150",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "用户类型",
      prop: "chooseClientType",
      type: "select",
      placeholder: "请选择用户类型",
      hide: true,
      formsolt: true,
      span: 12,
      dicData: DIC.WALLET_USER_TYPE,
      rules: [
        {
          required: true,
          trigger: "change",
          message: "请选择用户类型",
        },
      ],
    },
    {
      label: "用户账号",
      prop: "mobile",
      search: true,
      type: "input",
      formsolt: true,
      span: 10,
      rules: [
        {
          required: true,
          trigger: "change",
          message: "请输入正确的用户账号",
        },
      ],
    },
    {
      label: "姓名账号",
      prop: "showName",
      type: "input",
      hide: true,
      span: 12,
      formsolt: true,
    },
    {
      label: "用户姓名",
      prop: "realName",
      type: "input",
      addVisdiplay: false,
      search: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          message: "请输入用户姓名",
        },
      ],
    },
    {
      label: "金额",
      prop: "amount",
      type: "input",
      formsolt: true,
      span: 10,
      // rules: [{
      //     required: true,
      //     trigger: "blur",
      //     message: " "
      // }]
    },
    {
      label: "积分",
      prop: "integral",
      type: "input",
    },
    {
      label: "备注",
      prop: "remarks",
      type: "input",
      span: 10,
      //蒋龙焘觉得这太宽了,不要加宽
      // width: "330",
      rules: [
        {
          required: true,
          trigger: "blur",
          message: "请输入备注",
        },
      ],
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      sortable: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
      formatter: function(row) {
        return (row.createTime = row.createTime * 1);
      },
    },
    {
      label: "经销商名称",
      prop: "dealer",
      type: "input",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "工地地址",
      prop: "address",
      addVisdiplay: false,
    },

    {
      label: "预约卡",
      prop: "cardNumber",
      addVisdiplay: false,
    },
    {
      label: "产品类型",
      prop: "productType",
      addVisdiplay: false,
    },
    {
      label: "安装户型",
      prop: "houseType",
      addVisdiplay: false,
    },
    {
      label: "PPR管道系统",
      prop: "pprSystem",
      addVisdiplay: false,
    },
    {
      label: "用户类型",
      prop: "clientType",
      type: "select",
      placeholder: "请选择用户类型",
      search: true,
      addVisdiplay: false,
      dicData: DIC.WALLET_USER_TYPE,
      rules: [
        {
          required: true,
          trigger: "blur",
          message: "请选择用户类型",
        },
      ],
    },
    {
      label: "提现权限",
      prop: "withdrawable",
      type: "radio",
      valueDefault: "YES",
      dicData: DIC.WALLET_ABLE,
      hide: true,
      span: 10,
    },

    {
      label: "支付方式",
      prop: "rechargeWay",
      type: "radio",
      hide: true,
      span: 12,
      valueDefault: "BALANCE",
      dicData: DIC.WALLET_RECHARGE_WAY,
    },
    // {
    //     label: "凭证",
    //     prop: "url",
    //     type: 'input',
    //     solt: true,
    //     formsolt: true,
    //     span: 10,

    // },
    // {
    //     label: "创建人",
    //     prop: "createBy",
    //     type: "input",
    //     search: true,
    //     addVisdiplay: false,
    //     editVisdiplay: false
    // },
    {
      label: "创建时间",
      prop: "startDate_endDate",
      type: "datetimerange",
      valueFormat: "timestamp",
      span: 24,
      clearable: true,
      search: true,
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
      formatter: function(row) {
        console.log(row);
        return formatterTime(row.startTime) + "至" + formatterTime(row.endTime);
      },
    },
  ],
};
